import type { Analysis } from '../models/card-model';

const DEFAULT_MAX_LEN = 400;

/** Strip common markdown patterns for a readable one-line fallback from `content`. */
function plainTextFromMarkdown(md: string): string {
	if (!md?.trim()) return '';
	return md
		.replace(/^#{1,6}\s+/gm, '')
		.replace(/^\s*[-*+]\s+/gm, '')
		.replace(/\*\*([^*]+)\*\*/g, '$1')
		.replace(/\*([^*]+)\*/g, '$1')
		.replace(/`([^`]+)`/g, '$1')
		.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
		.replace(/^\|.+\|$/gm, ' ')
		.replace(/---+/g, ' ')
		.replace(/\n{2,}/g, '\n')
		.replace(/\n/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
}

function truncate(text: string, maxLen: number): string {
	if (text.length <= maxLen) return text;
	return `${text.slice(0, Math.max(0, maxLen - 1)).trimEnd()}…`;
}

/**
 * Headline text for the analysis card face: uses `headline`, else a plain-text excerpt from `content`.
 */
export function analysisCardFaceHeadline(
	item: Analysis,
	maxLen = DEFAULT_MAX_LEN
): string {
	const headline = item.headline?.trim();
	if (headline) return truncate(headline, maxLen);
	const body = plainTextFromMarkdown(item.content ?? '');
	if (body) return truncate(body, maxLen);
	const raw = (item.content ?? '').replace(/\s+/g, ' ').trim();
	return raw ? truncate(raw, maxLen) : '';
}
